import { AxiosError } from 'axios';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PhysicianRequest, PhysicianUniquenessError } from '../../../Data/Physician';
import { dictionary } from '../../../dictionary';
import { NotificationType } from '../../../redux/initialState';
import { addNotification } from '../../../redux/notifications/notificationsActionCreator';
import { physicianService } from '../../../Services/PhysicianService';
import { FormFlow, FormFlowStepComponent } from '../../../Shared/FormFlow/FormFlow';
import { routes } from '../../../Utils/routes';
import { PhysicianForm } from '../shared/PhysicianForm';

const PhysicianFormWrapper: FC<FormFlowStepComponent<PhysicianRequest>> = ({ FormActionsComponent, onFormStepComplete }) =>
  <PhysicianForm FormActionsComponent={FormActionsComponent} onFormStepComplete={onFormStepComplete} />;

export const CreatePhysician: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const onCancel = () => history.push(routes.physicians.index);
  const onComplete = async (request: PhysicianRequest) => {
    try {
      await physicianService.create(request);
      dispatch(addNotification(NotificationType.success, dictionary.CREATE_PHYSICIAN_SUCCESS));
      history.push(routes.physicians.index);
    } catch (exception) {
      const axiosErr = exception as AxiosError<PhysicianUniquenessError | { message: string }>;
      const response = axiosErr.response;
      if (response?.status === 409 && response?.data && typeof (response.data as any).message === 'string' && (response.data as any).message.includes(request.lastName)) {
        const uniquePhysicianError = (response.data as any).message as string;
        dispatch(addNotification(NotificationType.error, uniquePhysicianError));
      } else if (response?.status === 409) {
        const uniqueErr = response?.data as PhysicianUniquenessError | undefined;
        dispatch(addNotification(NotificationType.error, dictionary.PHYSICIAN_NOT_UNIQUE_ERROR(uniqueErr?.hospitalNames || [])));
      } else {
        dispatch(addNotification(NotificationType.error, dictionary.CREATE_PHYSICIAN_ERROR));
      }
    }
  };

  return (
    <FormFlow<PhysicianRequest>
      onComplete={onComplete}
      onCancel={onCancel}
      completeButtonLabel={dictionary.CREATE_PHYSICIAN_SUBMIT_BTN}
      steps={[
        { pageHeader: dictionary.CREATE_PHYSICIAN_PAGE_HEADER, component: PhysicianFormWrapper },
      ]}
    />
  );
};
